import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { provideRouter, withEnabledBlockingInitialNavigation, withRouterConfig } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
    OsApiAuthInterceptor,
    OsApiAuthModule,
    TrackingModule,
    TRANSLATION_FILES,
    TranslationService,
} from '@os-components';
import { LandingPageModule } from '@reg-features/landing-page/landing-page.module';
import { environment } from '../environments/environment';
import { WINDOW } from './core/constants';
import { routes } from './features/landing-page/landing-page-routing.module';
import { tracking } from './helpers/tracking';
import { TranslateInterceptor } from './interceptors/translate.interceptor';
import { CustomSerializer, reducers, routerFeatureKey } from './stores/router/router.reducer';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(
            routes,
            withEnabledBlockingInitialNavigation(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' })
        ),
        provideHttpClient(withInterceptorsFromDi()),
        importProvidersFrom(
            StoreModule.forRoot(reducers),
            EffectsModule.forRoot([]),
            StoreRouterConnectingModule.forRoot({ stateKey: routerFeatureKey }),
            TranslateModule.forRoot({
                defaultLanguage: environment.defaultLang,
                loader: {
                    provide: TranslateLoader,
                    useClass: TranslationService,
                },
            }),
            OsApiAuthModule.forRoot(
                {
                    xCsrfTokenUrl: `${environment.baseURLs.api.domain}${environment.baseURLs.api.token}`,
                },
                [
                    {
                        path: '/translate',
                        apiUrl: `${environment.baseURLs.api.domain}${environment.baseURLs.api.translation}`,
                        useXCsrfToken: false,
                        withCredentials: false,
                    },
                ]
            ),
            LandingPageModule,
            TrackingModule.forRoot({ appName: tracking.app, events: tracking.step })
        ),
        { provide: RouterStateSerializer, useClass: CustomSerializer },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OsApiAuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TranslateInterceptor,
            multi: true,
        },
        TranslationService,
        { provide: TRANSLATION_FILES, useValue: ['REG'] },
        { provide: WINDOW, useValue: window },
        ...(!environment.production ? [importProvidersFrom(StoreDevtoolsModule.instrument())] : []),
    ],
};
